@for (child of items; track $index; let i = $index) {
  @if (child.visible !== false) {
    <li
      [class]="child.badgeStyleClass ?? ''"
      [ngClass]="{ 'active-menuitem': isActive(i), separator: child.separator }">
      @if (!child.routerLink) {
        <a
          (click)="itemClick($event, child, i)"
          [attr.tabindex]="!visible ? '-1' : null"
          [attr.target]="child.target"
          [href]="child.url || '#'"
          [ngClass]="child.styleClass"
          pRipple>
          <i [ngClass]="child.icon"></i>
          <span class="label-max-length" translate>{{ child.label }}</span>
          @if (child.items) {
            <i class="fal fa-fw fa-angle-down layout-menuitem-toggler"></i>
          }
          @if (child.badge) {
            <span class="menuitem-badge">{{ child.badge }}</span>
          }
        </a>
      }
      @if (child.routerLink) {
        <a
          (click)="itemClick($event, child, i)"
          [attr.tabindex]="!visible ? '-1' : null"
          [attr.target]="child.target"
          [routerLink]="child.routerLink"
          [routerLinkActiveOptions]="{ exact: false }"
          pRipple
          routerLinkActive="active-menuitem-routerlink">
          <i [ngClass]="child.icon"></i>
          <span class="label-max-length" translate>{{ child.label }}</span>
          @if (child.items) {
            <i class="fal fa-fw fa-angle-down"></i>
          }
          @if (child.badge) {
            <span class="menuitem-badge">{{ child.badge }}</span>
          }
        </a>
      }
      <div class="layout-menu-tooltip">
        <div class="layout-menu-tooltip-arrow"></div>
        <div class="layout-menu-tooltip-text" translate>{{ child.label }}</div>
      </div>
      @if (child.items) {
        <ul
          [items]="child.items"
          [parentActive]="isActive(i)"
          [visible]="isActive(i)"
          [@children]="isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"
          app-submenu></ul>
      }
    </li>
  }
}
